var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.83C0 3.437 3.918 0 8.65 0c4.736 0 8.59 3.421 8.59 7.81 0 4.393-3.929 7.83-8.65 7.83-.85 0-1.697-.112-2.519-.332a.65.65 0 01.337-1.256c.712.191 1.445.288 2.182.288 4.138 0 7.35-2.983 7.35-6.53 0-3.551-3.146-6.51-7.29-6.51-4.148 0-7.35 2.982-7.35 6.53a5.93 5.93 0 001.117 3.47 3.65 3.65 0 01.144 3.531l.028-.006c.258-.061.49-.118.66-.173a.65.65 0 01.402 1.236c-.23.075-.513.143-.763.202l-.083.02c-.23.054-.425.1-.57.143-.43.128-.9-.009-1.147-.414-.227-.374-.17-.819.037-1.158a.644.644 0 01.04-.057 2.35 2.35 0 00.178-2.592A7.23 7.23 0 010 7.83zm0 0h.65H0z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09 8.829a.93.93 0 10-.14-1.855.93.93 0 00.14 1.855zM8.57 8.83a.93.93 0 100-1.86.93.93 0 000 1.86zM12.09 8.83a.93.93 0 10.192-1.85.93.93 0 00-.193 1.85z",
    fill: "#C4C4C4"
  })));
}
export default SvgChat;